// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type {
  CareersOpeningOverview,
  JobopeningCareersAvailable,
  JobopeningOpeningDescription,
  PublicJobOpening,
} from '../types';
import { createQueryKey } from '../utils/keys';

// ---------------------------------------------------------------
// Mutation Keys
// ---------------------------------------------------------------
export const patchJobopeningDescriptionMutationKey = [
  'patchJobopeningDescription',
] as const;
export const generateJobDescriptionMutationKey = [
  'generateJobDescription',
] as const;

// ---------------------------------------------------------------
// Query Keys
// ---------------------------------------------------------------
export const getPublicJobopeningQueryKey = (slug: string) =>
  createQueryKey<PublicJobOpening>()(['jobopenings', slug] as const);

export const getJobopeningCareersQueryKey = (workspaceId: number) =>
  createQueryKey<CareersOpeningOverview[]>()([
    'workspaces',
    workspaceId,
    'careers',
    'openings',
  ] as const);

export const getJobopeningCareersAvailableQueryKey = (workspaceId: number) =>
  createQueryKey<JobopeningCareersAvailable[]>()([
    'workspaces',
    workspaceId,
    'careers',
    'openings',
    'available',
  ] as const);

export const getJobopeningDescriptionQueryKey = (
  workspaceId: number,
  openingId: number
) =>
  createQueryKey<JobopeningOpeningDescription>()([
    'workspaces',
    workspaceId,
    'openings',
    openingId,
  ] as const);
